export default __webpack_public_path__ + "static/media/activation-screen.90523ada.png";